import { AlertCircle } from 'lucide-react-native'
import { Linking, Platform, StyleSheet, View } from 'react-native'
import { Button, Text, useTheme } from 'react-native-paper'

interface LocationPermissionWarningProps {
    isVisible: boolean
    onEnableDeviceFlag: () => void
}

export function LocationPermissionWarning({
    isVisible,
    onEnableDeviceFlag,
}: LocationPermissionWarningProps) {
    const theme = useTheme()

    if (!isVisible) return null

    const openSettings = () => {
        if (Platform.OS === 'ios') {
            Linking.openURL('app-settings:')
        } else {
            Linking.openSettings()
        }
    }

    return (
        <View style={[styles.container, { backgroundColor: theme.colors.errorContainer }]}>
            <View style={styles.header}>
                <AlertCircle size={24} color={theme.colors.error} />
                <Text
                    variant="titleSmall"
                    style={[styles.title, { color: theme.colors.onErrorContainer }]}
                >
                    Location Permission Required
                </Text>
            </View>
            <Text
                variant="bodyMedium"
                style={[styles.message, { color: theme.colors.onErrorContainer }]}
            >
                Background location tracking requires "Always" permission. Choose an option below:
            </Text>
            <View style={styles.actions}>
                <Button mode="contained" onPress={openSettings} style={styles.button} compact>
                    Grant Permission
                </Button>
                <Button mode="outlined" onPress={onEnableDeviceFlag} style={styles.button} compact>
                    Disable on This Device
                </Button>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        padding: 16,
        borderRadius: 8,
        gap: 12,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    title: {
        fontWeight: '600',
    },
    message: {
        lineHeight: 20,
    },
    actions: {
        flexDirection: 'row',
        gap: 12,
        flexWrap: 'wrap',
    },
    button: {
        flex: 1,
        minWidth: 120,
    },
})
